import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/customapps";
import Title from "../components/common/Title";
import "../resources/styles/BigCalendar.css";
import colors, { colorsV2 } from "../styles/colors";
import layout from "../styles/layout";
import AppFrame from "./Appframe/AppFrame";
import IconDelete from "material-ui/svg-icons/action/delete-forever";
import { Mixpanel } from "../mixpanel";

import { makeStyles } from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Icon } from "@material-ui/core";

import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

const localizer = momentLocalizer(moment);

const style = {
  pointsEarnedLable: {
    color: colors.text,
    textAlign: "right",
    fontSize: 20,
    fontWeight: 900,
  },
  progressContainer: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    margin: 20,
  },
  progressContainerItem: {
    flex: "1",
    margin: 20,
    minWidth: 370,
  },
  instructionItem: {
    background: "#FFFFFF",
    borderBottom: "1px solid #E5E5E5",
  },
  button: {
    width: 160,
    border: "2px solid grey",
    borderRadius: 8,
    padding: 4,
    marginRight: 4,
    marginLeft: 4,
  },
  buttonImage: {
    width: 24,
    height: 24,
    padding: 5,
    margin: 0,
    border: "2px solid #52829D",
    borderRadius: 18,
  },
  dateField: {
    maxWidth: 150,
    fontSize: 16,
    fontWeight: 600,
    height: 35,
  },
};

const instructionPreviewStyle = {
  pageLetter: {
    width: "215.9mm",
    height: "288.5mm",
    padding: "5mm",
    display: "flex",
    flexFlow: "column",
    alignItems: "left",
    alignSelf: "center",
  },
  mainHeader: {
    fontSize: 32,
    fontWeight: "bold",
    color: "#696969",
    marginTop: 10,
    marginBottom: 0,
  },
  subHeader: {
    fontSize: 26,
    textAlign: "center",
    color: colors.primary,
  },
  body: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: "#696969",
    textAlign: "left",
    margin: 20,
  },
  instructionDetail: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "EditorFormatAlignCenter",
    marginBottom: 10,
    flexWrap: "wrap",
  },
  labelContainer: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: "#696969",
    maringBottom: 5,
    alignItems: "center",
    display: "flex",
    flexWrap: "wrap",
  },
  label: {
    marginRight: 5,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: colors.steelBlue,
  },
  row: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "center",
    margin: 20,
  },
  instructionImage: {
    height: 240,
  },
  mediaContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
};

const classes = makeStyles({
  table: {
    minWidth: 650,
  },
});

class PatientProgress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: props.match.params.userId,
      appId: props.match.params.appId,
      customApp: {},
      width: 0,
      height: 0,
      instruction: {},
      userActivities: [],
      selectedDate: new Date(),
      selectedActivitiesForPoints: [],
      activityDate: new Date(),
      showInstructionPopup: false,
      isCollectPointsDialogOpen: false,
    };

    this.activitiesRef = React.createRef();
    this.deleteActivity = this.deleteActivity.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    this.props.fetchCustomApp(this.state.appId, this.state.userId);
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.state.userId &&
      this.state.appId &&
      _.isEmpty(this.state.customApp) &&
      !_.isEmpty(nextProps.customapps.customApps[this.state.appId])
    ) {
      Mixpanel.track("Patient view progress", { "User ID": this.state.userId });
      const customApps = nextProps.customapps.customApps[this.state.appId];
      this.setState({
        customApp: customApps[this.state.userId],
      });
      this.props.getUserActivityForCustomApp(
        this.state.userId,
        customApps[this.state.userId].customAppId
      );
    }

    if (nextProps.customapps.userActivity) {
      let startDate =
        nextProps.customapps.userActivity.length > 0
          ? nextProps.customapps.userActivity[0].activityDate
          : new Date();
      let endDate = new Date();
      this.setState({
        userActivities: nextProps.customapps.userActivity,
        startDate,
        endDate,
      });
    }
  }
  printElement = (element) => {
    if (!element) return;

    const iframe = document.createElement("iframe");
    iframe.style.position = "absolute";
    iframe.style.top = "-10000px";
    iframe.style.left = "-10000px";
    document.body.appendChild(iframe);

    const docTarget = iframe.contentWindow || iframe.contentDocument;
    const printDoc = docTarget.document || docTarget;

    printDoc.open();
    printDoc.write("<html><head><title>&nbsp;</title>");

    const styleNodes = Array.from(
      document.querySelectorAll("style, link[rel='stylesheet']")
    );
    styleNodes.forEach((node) => {
      printDoc.write(node.outerHTML);
    });

    printDoc.write("</head><body>");
    printDoc.write(element.outerHTML);
    printDoc.write("</body></html>");
    printDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 500);
    };
  };

   handlePrintClick = () => {
    this.printElement(this.activitiesRef.current);
  };

  handleStartDateChange(date) {
    this.setState({ startDate: date });
  }
  handleEndDateChange(date) {
    this.setState({ endDate: date });
  }

  renderUserActivities() {
    return (
      <div ref={this.activitiesRef}>
      <div className="print-activity-header">
        <h3 style={{ margin: 0, color: "#34495e" }}>Patient Activity Report</h3>
        <div style={{ fontSize: 14, color: "#555" }}>
          Date Range: {this.formatDate(this.state.startDate || new Date())} - {this.formatDate(this.state.endDate || new Date())}
        </div>
      </div>
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow className="print-activity-header-row">
              <TableCell>Date Of Activity</TableCell>
              <TableCell align="right">Activity Completed</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.state.userActivities != null &&
              this.state.userActivities.map((row) => {
                let lastDate = null;
                let dateRow = null;
                if (lastDate !== row.activityDate) {
                  lastDate = row.activityDate;
                  dateRow = this.formatDate(row.activityDate);
                } else {
                  dateRow = "";
                }
                return (
                  <TableRow key={row.activityId}>
                    <TableCell component="th" scope="row">
                      {dateRow}
                    </TableCell>
                    <TableCell align="right">{row.instructionName}</TableCell>
                  </TableRow>
                );
              })}

            {this.state.userActivities == null && (
              <TableCell align="right" colSpan={10}>
                <h1>Loading....</h1>
              </TableCell>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      </div>
    );
  }

  renderUserActivitiesOld() {
    /*
    const filteredActivities = this.state.userActivities.filter((actRow) => {
      return (
        this.formatDate(actRow.activityDate) ==
        this.formatDate(this.state.selectedDate)
      );
    });

    if (filteredActivities.length < 1) {
      return <p>No activity on this day.</p>;
    } else {
      return (
        <List>
          {filteredActivities.map((activity) => {
            return (
              <div>
                <ListItem
                  primaryText={activity.instructionName}
                  style={style.instructionItem}
                  disableTouchRipple={true}
                  rightIconButton={
                    <IconButton
                      onClick={() => {
                        this.deleteActivity(
                          activity.userActivityId,
                          activity.customAppId
                        );
                      }}
                    >
                      <IconDelete />
                    </IconButton>
                  }
                />
              </div>
            );
          })}
        </List>
      );
    }
    */
    return null;
  }

  deleteActivity(activityId, customAppId) {
    this.props.deleteActivityFromCustomApp(
      this.state.userId,
      activityId,
      customAppId,
      this.state.appId
    );

    Mixpanel.track("Patient delete an activity", {
      "Patient ID": this.state.userId,
      "Activity ID": activityId,
      "Channel ID": customAppId,
    });
    const filteredActList = this.state.userActivities.filter(
      (item) => item.userActivityId !== activityId
    );

    this.setState({ userActivities: filteredActList });
  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  formatGoalToDate(dt) {
    const dtSplit = dt.split("-");
    return [dtSplit[2], dtSplit[0], dtSplit[1]].join("-");
  }

  getCalendarDates() {
    let markedDates = {};

    // Assign css class to goal dates
    if (this.state.customApp.goals && this.state.customApp.goals[0]) {
      let curDate = new Date(
        this.formatGoalToDate(this.state.customApp.goals[0].startDate)
      );
      let endDate = new Date(
        this.formatGoalToDate(this.state.customApp.goals[0].endDate)
      );

      curDate = this.addDays(curDate, 1);

      while (curDate <= this.addDays(endDate, 1)) {
        markedDates[this.formatDate(curDate)] = "date-item goal-date-mark";
        curDate = this.addDays(curDate, 1);
      }
    }
    //Assign css class to activity dates
    if (this.state.userActivities) {
      this.state.userActivities.map((activity) => {
        markedDates[this.formatDatePlusOne(activity.activityDate, 1)] =
          "date-item activity-date-mark";
      });
    }

    //Assign css class to current selected date
    markedDates[this.formatDate(this.state.selectedDate)] =
      "date-item selected-date-mark";

    return markedDates;
  }

  renderCalendar() {
    let markedDates = this.getCalendarDates();
    return (
      <Calendar
        localizer={localizer}
        events={[]}
        startAccessor="start"
        endAccessor="end"
        toolbar={true}
        views={["month"]}
        style={{ width: 400, height: 300 }}
        selectable={"true"}
        onSelectSlot={this.handleDateSelected}
        components={{
          month: {
            dateHeader: ({ date, label }) => (
              <p className={markedDates[this.formatDate(date)]}>{label}</p>
            ),
          },
        }}
      />
    );
  }

  handleDateSelected = ({ start, end, action }) => {
    this.setState({ selectedDate: start });
    Mixpanel.track("Patient views activity by calendar", {
      "User ID": this.state.userId,
    });
  };

  formatDate(date) {
    var d = date.year
        ? new Date(date.year, date.month - 1, date.day)
        : new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [month, day, year].join("/");
  }

  formatDatePlusOne(date) {
    var d = date.year
      ? new Date(date.year, date.month - 1, date.day)
      : new Date(date);

    let month = (d.getMonth() + 1).toString();
    let day = d.getDate().toString();
    let year = d.getFullYear().toString();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  handleActivityDateChanged = (event, date) => {
    this.setState({ activityDate: date });
  };

  render() {
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame
        auth={this.props.auth}
        targetDevice={targetDevice}
        header="Patient Activity"
        optionsType="userApp"
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <div style={layout.common.page}>
          <Title
            goBack={() => this.props.history.goBack()}
            whiteLabelSettings={this.props.whiteLabelSettings}
          />
        </div>
        {/* 
        <div style={layout.common.page}>
          <Title
            text2={"Logged Activities"}
            goBack={() => this.props.history.goBack()}
          />

          <div style={layout.common.mainContainer}>
            <div style={style.progressContainer}>
              <div style={style.progressContainerItem}>
                {this.renderCalendar()}
              </div>

              <div style={style.progressContainerItem}>
                <p style={layout.common.label}>
                  {`Completed Activities - ${this.state.selectedDate.toLocaleDateString()}`}{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
    */}
        <Paper
          style={{
            marginLeft: 30,
            padding: 30,
            width: "70%",
            alignSelf: "center",
          }}
          elevation={5}
        >
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignContent: "center",
                marginBottom: 15,
              }}
            >
              <h2 style={{ color: colorsV2.primary }}>
                Select Activity Date Range
              </h2>
              <Button variant="outlined" onClick={this.handlePrintClick}>
                <Icon name="print" />
                Print Patient Activity Report
              </Button>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                alignContent: "center",
              }}
            >
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="startDate-picker-inline"
                  label="Start Date"
                  value={this.state.startDate}
                  onChange={this.handleStartDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "Chang End Date",
                  }}
                />
                <KeyboardDatePicker
                  disableToolbar
                  variant="inline"
                  format="MM/dd/yyyy"
                  margin="normal"
                  id="endDate-picker-inline"
                  label="End Date"
                  value={this.state.endDate}
                  onChange={this.handleEndDateChange}
                  KeyboardButtonProps={{
                    "aria-label": "Change End Date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          {this.state.userActivities && this.renderUserActivities()}
        </Paper>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, customapps }) {
  return {
    user,
    customapps,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PatientProgress);



// WEBPACK FOOTER //
// ./src/layout/PatientProgress.js